import React, {useEffect, useState} from 'react';
import CustomModal from "../../../components/UI/CustomModal";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {Drawer} from "antd";
import {
    SELECT_DATE_MODAL,
    TRIAL_COURSE_SESSION_MODAL,
    updateModalRes
} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import {useDispatch, useSelector} from "react-redux";
import {Btn, ErrorText, FlexColumnSection, FlexRowSection, SmallHeader} from "../../../styles/globalStyles";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {t} from "i18next";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CustomSelect from "../../../components/UI/CustomSelect";
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";
import dayjs from "dayjs";
import {DB_DATE_FORMAT} from "@arboxappv4/shared/src/constants/constants";

const TrialCourseSessionSelect = (props) => {
    const { isOpen, onClose, course} = props;
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const [session, setSession] = useState(null);
    const [showError, setShowError] = useState(false);
    const [sessionOptions, setSessionOptions] = useState([]);

    const {isMobile} = useScreenSize();
    const dispatch = useDispatch()

    useEffect(() => {
        if(course) {
            getOpenSessions()
        }
    }, [course]);

    const getOpenSessions = async () => {
        const res = await apiAction('site/getSeriesSessionsForTrial', 'post', {series_id: course.id});
        const options = res.map(opt => {
            const sessionDate = dayjs(opt.date, DB_DATE_FORMAT)
            const label = t('trial-hug-session-select', {date: sessionDate.format(globalLocation.date_format), day: t(`day-short-${sessionDate.day()}`), time: `${dayjs(opt.time, 'HH:mm').format(globalLocation.time_format)} - ${dayjs(opt.end_time, 'HH:mm').format(globalLocation.time_format)}`, interpolation: {'escapeValue': false}})
            return {...opt, label: label, value: opt.id,}
        })
        setSessionOptions(options)
    }

    const onSessionSelected = () => {
        if(session) {
            setShowError(false)
            dispatch(updateModalRes({modalName: TRIAL_COURSE_SESSION_MODAL, res: session}))
            onClose()
        } else {
            setShowError(true)
        }
    }

    const getSessionSelectComp = () => {
        return (
            <FlexColumnSection gap={'20px'}>
                <FlexRowSection justify={'space-between'}>
                    <SmallHeader fontSize={'18px'}>{t('hug-trial-session-select-header')}</SmallHeader>
                    {isMobile && <div onClick={onClose}><FontAwesomeIcon icon={light('x')} color={Colors.siteBlack} size={'xs'}/></div>}
                </FlexRowSection>
                <FlexColumnSection gap={'10px'}>
                    <CustomSelect dontSort={true} onChange={(val) => setSession(val)} options={sessionOptions} placeholder={t('select-hug-trial-session-placeholder')} enableSingleSelection={true}/>
                    {showError && <ErrorText>{t('select-hug-trial-session-error')}</ErrorText>}
                </FlexColumnSection>
                <FlexRowSection gap={'10px'} justify={'end'}>
                    <Btn onClick={onClose}>{t('close')}</Btn>
                    <Btn type={'primary'} onClick={onSessionSelected}>{t('proceed')}</Btn>
                </FlexRowSection>
            </FlexColumnSection>
        )
    }

    return (
        <>
            {
                isMobile ?
                    <Drawer classNames={{body: 'select-date-mobile-drawer-body'}}
                            placement={'bottom'}
                            closable={false}
                            onClose={onClose}
                            open={isOpen}
                            style={{borderTopLeftRadius: 20, borderTopRightRadius: 20}}
                    >
                        {getSessionSelectComp()}
                    </Drawer>
                    :
                    <CustomModal open={isOpen} onCancel={onClose} width={'500px'}>
                        {getSessionSelectComp()}
                    </CustomModal>
            }
        </>

    );
};

export default TrialCourseSessionSelect;